module.exports = __webpack_public_path__ + "static/media/caret-down-menu.91130d72.svg";